import { render, staticRenderFns } from "./TrackingForPayPalMobile.vue?vue&type=template&id=5faa3cf6&scoped=true"
import script from "./TrackingForPayPalMobile.vue?vue&type=script&lang=js"
export * from "./TrackingForPayPalMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5faa3cf6",
  null
  
)

export default component.exports